export default "__VITE_ASSET__Zy19cL$W__"